module.exports = __webpack_public_path__ + "static/media/SO2_OUTOFRANGE.3164ed20.png";